import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import debounce from 'lodash/debounce';
import { Paper, Button } from '@material-ui/core';
import { getMembrosByNome } from '../../../services/GruposApi';

const useStyles = makeStyles(theme => ({
    root: {
        height: '80vh',
        overflow: 'auto',
        backgroundColor: theme.palette.background.paper,
        paddingTop: 20,
    },
    inline: {
        display: 'inline',
    },
    cadastrarButton: {
        fontSize: 11,
        margin: theme.spacing(1),
    },
    textfield: {
        width: '100%',
    },
    item: {
        paddingTop: '20px',
        paddingBottom: '20px',
        minWidth: '300px',
    },
    itemPesquisa: {
        paddingBottom: '20px',
    },
    large: {
        width: theme.spacing(5),
        height: theme.spacing(5),
    },
    divButton: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
    },
    legenda: {
        marginTop: 20,
    },
}));

export default function PesquisarMembrosList({
    clickMembro,
    clickCadastrarNovoMembro,
}) {
    const classes = useStyles();
    const history = useHistory();
    const [membros, setMembros] = React.useState([]);
    const [inputPesquisa, setinputPesquisa] = React.useState(undefined);
    const debounceOnChange = React.useCallback(debounce(onChange, 600), []);

    async function fetchMembrosNyNome(nome) {
        try {
            const response = await getMembrosByNome(nome);
            setMembros(response.data);
        } catch (error) {}
    }

    useEffect(() => {
        if (inputPesquisa) {
            fetchMembrosNyNome(inputPesquisa);
        }
    }, [inputPesquisa]);

    async function onChange(value) {
        setinputPesquisa(value);
    }

    return (
        <Paper className={classes.root}>
            <div className={classes.divButton}>
                <div>
                    {/*<Button
                        onClick={clickCadastrarNovoMembro}
                        variant="contained"
                        color="primary"
                        className={classes.cadastrarButton}
                    >
                        Cadastrar Novo Membro
                    </Button>*/}
                    <Button
                        onClick={() => history.goBack()}
                        variant="contained"
                        className={classes.cadastrarButton}
                    >
                        Voltar
                    </Button>
                </div>
                <Typography
                    className={classes.legenda}
                    align="center"
                    variant="caption"
                >
                    Utilize a caixa de pesquisa abaixo para localizar os membros
                    da igreja que fazem parte do seu GA. Você pode pesquisar por
                    matrícula ou nome (parcial ou completo). Ao localizar,
                    selecione-o e clique no botão "INCLUIR NO MEU GRUPO".
                </Typography>
            </div>

            <List>
                <ListItem
                    divider
                    className={classes.itemPesquisa}
                    alignItems="flex-start"
                >
                    <TextField
                        className={classes.textfield}
                        id="outlined-basic"
                        label="Nome ou a Matrícula"
                        onChange={e => debounceOnChange(e.target.value)}
                        size="small"
                        variant="outlined"
                    />
                </ListItem>
                {membros.map(row => (
                    <ListItem
                        key={row.idAluno}
                        divider
                        className={classes.item}
                        button
                        onClick={e => clickMembro(e, row)}
                        alignItems="center"
                    >
                        <ListItemAvatar>
                            <Avatar
                                className={classes.large}
                                src={row.txFotoUrl}
                            />
                        </ListItemAvatar>

                        <ListItemText
                            primary={<span translate="no">{row.txAluno}</span>}
                            secondary={
                                <>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inline}
                                        color="textPrimary"
                                    >
                                        Tel: {row.txTelefoneCel}
                                    </Typography>
                                </>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
}
